import { Grid } from '../ui/Card';
import { SkeletonCard, SkeletonHeader, SkeletonKpi, SkeletonPage, SkeletonRegion } from '../ui/Skeleton';
import { useT } from '../../i18n';
import { COMMON } from '../../i18n/common';
import { defineMessages } from '../../i18n/define';

const m = defineMessages({
  districtLoading: { id: 'shell.skeleton.district', defaultMessage: 'обзор района', description: 'Что загружается (подпись скелетона «Обзор района» для диктора), строчными' },
  districtTitle: { id: 'shell.skeleton.districtTitle', defaultMessage: 'Обзор района', description: 'Заголовок скелетона главной страницы хокима, пока грузится экран' },
  now: { id: 'shell.skeleton.now', defaultMessage: 'Сейчас в поле', description: 'Заголовок карточки-заглушки: что сейчас идёт в поле' },
  decisions: { id: 'shell.skeleton.decisions', defaultMessage: 'От решения к результату', description: 'Заголовок карточки-заглушки: ход от поручения до результата' },
  attention: { id: 'shell.skeleton.attention', defaultMessage: 'Где нужно разобраться', description: 'Заголовок карточки-заглушки: где нужно внимание хокима' },
});
import './shell.css';

/**
 * Оболочка, пока `/auth/me` не ответил (agroai-6al.49): сайдбар, шапка и
 * скелетон страницы на своих местах, а не пустой экран со строкой. Роль ещё
 * неизвестна, поэтому пунктов меню нет — только рама.
 */
export function ShellSkeleton() {
  const t = useT();
  return (
    <SkeletonRegion label={t(COMMON.loadingCabinet)} quiet className="shell">
      <span className="visually-hidden">{t(COMMON.checkingSignIn)}</span>
      <aside className="sidebar" aria-hidden="true" />
      <div className="main">
        <div className="topbar" aria-hidden="true" />
        <main className="content">
          <div className="content__inner">
            <PageFallback path={typeof window === 'undefined' ? '/' : window.location.pathname} />
          </div>
        </main>
      </div>
    </SkeletonRegion>
  );
}

/**
 * Скелет на время загрузки кода раздела и роли. Обзор района — первая страница
 * хокима — держит свою раскладку (шесть KPI, «Сейчас в поле | От решения к
 * результату», «Где нужно разобраться»), иначе при перезагрузке верстка
 * прыгала с четырёх KPI на шесть (O8). Остальные разделы — общая форма.
 * Лёгкий: не тянет в основной пакет сам экран обзора.
 */
export function PageFallback({ path }: { path: string }) {
  const t = useT();
  if (path !== '/') return <SkeletonPage label={t(COMMON.loadingSection)} />;
  return (
    <SkeletonPage label={t(m.districtLoading)} className="district">
      <SkeletonHeader title={t(m.districtTitle)} controls={3} />
      <Grid cols={6}>
        {Array.from({ length: 6 }, (_, i) => <SkeletonKpi key={i} quiet />)}
      </Grid>
      <Grid cols="7-5">
        <SkeletonCard quiet title={t(m.now)} height={200} />
        <SkeletonCard quiet title={t(m.decisions)} height={200} />
      </Grid>
      <SkeletonCard quiet size="lg" title={t(m.attention)} height={320} />
    </SkeletonPage>
  );
}
